import addAvailableProductsToOptions from "./addAvailableProductsToOptions";

export default (options, configurations) =>
  options && configurations
    ? addAvailableProductsToOptions(options, configurations)
    : [];
